import Crud from '../views/Role/Crud'
import Entity from '../views/Role/Add'

let routes = {
    path: '/roles',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/roles/add',
            name: 'NewRole',
            component: Entity,
            meta: {
                pageTitle: 'Papel',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Papel',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/roles/edit/:id?',
            name: 'EditRole',
            component: Entity,
            meta: {
                pageTitle: 'Papel',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Papel',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/roles',
            name: 'list-roles',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Papéis',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Papéis',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
